// extracted by mini-css-extract-plugin
export default {"appLoader":"Vb9T9WX"};